import jQuery from "jquery";
import "slick-carousel";

export default () => ({
	expanded: 0,
	slider: null,
	maxItems: 0,
	sliderLeft: null,
	sliderRight: null,
	animating: false,
	init() {
		this.slider = this.$root.querySelector(".slideshow--left");
		this.maxItems = this.slider.querySelectorAll(".item").length;
		this.sliderLeft = this.$root.querySelector(".slideshow--left .slider");
		this.sliderRight = this.$root.querySelector(
			".slideshow--right .slider"
		);

		window.addEventListener("resize", (e) => {
			this.resizer();
		});

		this.$nextTick(() => {
			this.resizer();
			this.initSlider();
		});
	},
	initSlider() {
		jQuery(this.sliderLeft)
			.slick({
				vertical: true,
				verticalSwiping: true,
				arrows: false,
				infinite: true,
				dots: false,
				speed: 1000,
				adaptiveHeight: true,
				cssEase: "cubic-bezier(0.7, 0, 0.3, 1)",
			})
			.on("beforeChange", (event, slick, currentSlide, nextSlide) => {
				this.expanded = nextSlide;
				this.animating = true;
				if (
					currentSlide > nextSlide &&
					nextSlide == 0 &&
					currentSlide == this.maxItems
				) {
					var sliderRightGoTo = -1;
				} else if (
					currentSlide < nextSlide &&
					currentSlide == 0 &&
					nextSlide == this.maxItems - 1
				) {
					var sliderRightGoTo = 0;
				} else {
					var sliderRightGoTo = this.maxItems - 1 - nextSlide;
				}
				jQuery(this.sliderRight).slick("slickGoTo", sliderRightGoTo);
			})
			.on("afterChange", () => {
				this.animating = false;
			});

		jQuery(this.sliderRight).slick({
			swipe: false,
			dots: false,
			vertical: true,
			arrows: false,
			infinite: false,
			adaptiveHeight: true,
			speed: 950,
			cssEase: "cubic-bezier(0.7, 0, 0.3, 1)",
			initialSlide: this.maxItems - 1,
			lazyLoad: "progressive",
		});
	},
	resizer() {
		let mql = window.matchMedia("(max-width: 1023px)");
		let contentCol = this.$root.querySelector(".content-column");
		let contentColRect = contentCol.getBoundingClientRect();

		let height = mql.matches ? "16rem" : contentColRect.height + "px";

		let imageCols = this.$root.querySelectorAll(".image-column .inner");
		[...imageCols].forEach((v, i, a) => {
			v.style.height = height;
		});
	},
	change(key) {
		if (this.animating) return false;
		let index = this.expanded !== key ? key : 0;
		this.expanded = index;
		jQuery(this.sliderLeft).slick("slickGoTo", index);
	},
});
